import { defineChain } from "viem";

export const SHARED_DISTRIBUTOR = "0x42C3a17a439CA3fE9b2cD74D0C52b359a982AFF8";

export const CHAINS = {
  robinhood: {
    id: "robinhood", name: "Robinhood", symbol: "ETH", color: "#00c805", logo: "https://gateway.pinata.cloud/ipfs/QmZHPNgBteaDHeiH7aHE1Tedf1QVeVArkX7e2QiPS1hxdA",
    chainId: 4663, rpc: "https://empty-empty-butterfly.robinhood-mainnet.quiknode.pro/dd257c8a05846c1381992d9b8ff6c0e8d2693306/",
    explorer: "https://robinhoodchain.blockscout.com", factory: "0x475FBe1C2eBf84B67902F8b7dD4B6A9CAC104638", graduation: "4",
  },
  base: {
    id: "base", name: "Base", symbol: "ETH", color: "#0052ff", logo: "https://ipfs.io/ipfs/QmeKJGSw14vUTmuD6fEXEP4JkUP9YnAZEKPTxZERo8GrE3",
    chainId: 8453, rpc: "https://mainnet.base.org", explorer: "https://basescan.org", factory: "0x521db9e760f787487379Ee53f89784706BCFfad6", graduation: "4",
  },
  bnb: {
    id: "bnb", name: "BNB Chain", symbol: "BNB", color: "#f0b90b", logo: "https://ipfs.io/ipfs/QmZ7KhPTsUwj1MjMXNHvLg88Yyjep1RfmB5Dx4kPZL8ufj",
    chainId: 56, rpc: "https://bsc-dataseed.binance.org", explorer: "https://bscscan.com", factory: "0xb34F0a43CB9AD045C770B5e1f663525addbc114F", graduation: "4",
  },
  ethereum: {
    id: "ethereum", name: "Ethereum", symbol: "ETH", color: "#8b95a7", logo: "https://ipfs.io/ipfs/QmcSxPFfRGkdpGVByphT3grLWLgTNYDXBxRWAbegnuVaKh",
    chainId: 1, rpc: "https://ethereum-rpc.publicnode.com", explorer: "https://etherscan.io", factory: "0xD97b4Dc8b62a064243ad4C0a3fbf235f5Bf0F44b", graduation: "4",
  },
  monad: {
    id: "monad", name: "Monad", symbol: "MON", color: "#836ef9", logo: "https://gateway.pinata.cloud/ipfs/QmZ2iwEa6dFW2S3UoqMtiiKqAeCZjKqiCpksbSvmYhJoc8",
    chainId: 143, rpc: "https://rpc.monad.xyz", explorer: "https://explorer.monad.xyz", factory: "0xbCC254dE4Be83e2747C701B5193Cee7a465c53F6", graduation: "200000",
  },
};

export const wagmiChains = Object.values(CHAINS).map((chain) => defineChain({
  id: chain.chainId,
  name: chain.name,
  nativeCurrency: { name: chain.symbol, symbol: chain.symbol, decimals: 18 },
  rpcUrls: { default: { http: [chain.rpc] } },
  blockExplorers: { default: { name: `${chain.name} Explorer`, url: chain.explorer } },
}));

export const MODES = {
  wallet: { label: "Creator Wallet", group: "creators", description: "All creator-side fees accrue to the developer.", percentages: { developer: 100, holders: 0, burn: 0, liquidity: 0 } },
  shareholders: { label: "Shareholders", group: "apps", icon: "https://gateway.pinata.cloud/ipfs/QmQZ8e2ZbJmTS3SbgLFYn8wKfTnVCEFsmPB5kne9r2FGxW", description: "On-chain proportional rewards for token holders.", percentages: { developer: 30, holders: 60, burn: 0, liquidity: 10 } },
  deflationary: { label: "Deflationary", group: "apps", icon: "https://ipfs.io/ipfs/Qmc3gGaDpYqxj6jwjsoyk4Ar4gT8LYUQ1ASf5vw2A5CuBZ", description: "Uses fees for buybacks and permanent burns.", percentages: { developer: 10, holders: 0, burn: 90, liquidity: 0 } },
  lottery: { label: "Lottery", group: "apps", icon: "https://ipfs.io/ipfs/QmP5MgDyS36TeWvNWNChynG2uKCbNMNPsEoWw7cCEvQkAf", description: "Verifiable on-chain lottery rounds for holders.", percentages: { developer: 30, holders: 70, burn: 0, liquidity: 0 } },
  liquidity: { label: "Liquidity", group: "apps", icon: "https://ipfs.io/ipfs/QmVGuj53StqvjyJCJ41roH9ijHccgKLU5igSEtZpdVeXYc", description: "Uses fees to grow liquidity in the V4 pool.", percentages: { developer: 30, holders: 0, burn: 0, liquidity: 70 } },
};
